// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"553f4914","135":"f34dbad4","259":"47543f8f","264":"55dd1249","384":"1bd03dd2","387":"0c42675b","426":"e825f254","511":"329bb5c4","915":"25c93a17"}[chunkId] + ".chunk.js";
};